/**
 * Score arcade (phase A) : points par rôle × multiplicateur de série. Le multiplicateur monte à chaque
 * destruction, retombe à 1 sans destruction pendant la fenêtre de série, ou quand le joueur est abattu.
 */
import type { Ship } from '../entities';
import type { DamageInfo, SimState } from '../state';

export function onScoreKill(state: SimState, ship: Ship, info: DamageInfo): void {
  if (info.source !== 'player' || ship.team !== 'enemy') return;
  const rules = state.data.waves.scoring;
  const role = ship.kind as keyof typeof rules.points;
  const base = rules.points[role] ?? 0;
  const score = state.score;
  const gained = Math.round(base * score.multiplier);
  score.total += gained;
  score.multiplier = Math.min(rules.multiplierMax, score.multiplier + rules.multiplierStep);
  score.bestMultiplier = Math.max(score.bestMultiplier, score.multiplier);
  score.streakTimer = rules.streakWindow;
  state.emit({ type: 'score', time: state.time, gained, total: score.total, multiplier: score.multiplier, role: ship.kind });
}

export function updateScore(state: SimState, dt: number): void {
  const score = state.score;
  if (score.multiplier <= 1) return;
  score.streakTimer -= dt;
  if (score.streakTimer <= 0) resetStreak(state);
}

export function resetStreak(state: SimState): void {
  if (state.score.multiplier <= 1) return;
  state.score.multiplier = 1;
  state.score.streakTimer = 0;
  state.emit({ type: 'streakLost', time: state.time });
}
